
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Table, TableHead, TableBody, TableCell, TableRow, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddBox';
import RemoveIcon from '@material-ui/icons/IndeterminateCheckBox';
import FormTextField from '../legacyForm/FormTextField';
import Map from '../map/Map';
import FormParcelAutocompleteField from '../form/FormParcelAutocompleteField';
import { findPlace } from '../../utils/placesApi';
import * as logger from '../../utils/logger';
import { connect } from 'react-redux';

const required = value => value ? undefined : 'Pole jest wymagane';

class BudgetApplicationLocations extends Component {
  handleAddItem = () => this.props.fields.push({});

  handleAddressChange = index => {
    if (this.props.locations[index].address && this.props.locations[index].city) {
      findPlace(`${this.props.locations[index].address}, ${this.props.locations[index].city}`)
        .then(location => {
          this.props.change(`locations[${index}].lat`, location.lat);
          this.props.change(`locations[${index}].lng`, location.lng);
        })
        .catch(error => {
          if (this.props.cms.location) {
            this.props.change(`locations[${index}].lat`, this.props.cms.location.lat);
            this.props.change(`locations[${index}].lng`, this.props.cms.location.lng);
          }
          logger.error(error);
        });
    } else if (this.props.cms.location && (this.props.locations[index].address || this.props.locations[index].city)) {
      this.props.change(`locations[${index}].lat`, this.props.cms.location.lat);
      this.props.change(`locations[${index}].lng`, this.props.cms.location.lng);
    }
  }

  handleMarkerMoved = ({ id, lat, lng }) => {
    this.props.change(`locations[${id}].lat`, lat);
    this.props.change(`locations[${id}].lng`, lng);
  }

  render() {
    const { fields, applicationForm, budgetId, parcelsAutocompletion, locations, readonly } = this.props;

    return (
      <React.Fragment>
        <div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="none">Pełny adres</TableCell>
                <TableCell size="small">Miejscowość</TableCell>
                <TableCell padding="none">Opis</TableCell>
                <TableCell size="small">Numer działki</TableCell>
                <TableCell padding="none" align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map((locationRow, index) => (
                <TableRow key={index}>
                  <TableCell padding="none">
                    <Field
                      name={`${locationRow}.address`}
                      component={FormTextField}
                      fullWidth
                      disabled={readonly}
                      validate={applicationForm.locationAddressRequired ? required : null}
                      onBlur={() => this.handleAddressChange(index)}
                    />
                  </TableCell>
                  <TableCell size="small">
                    <Field
                      name={`${locationRow}.city`}
                      component={FormTextField}
                      fullWidth
                      disabled={readonly}
                      validate={applicationForm.locationCityRequired ? required : null}
                      onBlur={() => this.handleAddressChange(index)}
                    />
                  </TableCell>
                  <TableCell padding="none">
                    <Field
                      name={`${locationRow}.description`}
                      component={FormTextField}
                      fullWidth
                      disabled={readonly}
                      validate={applicationForm.locationDescriptionRequired ? required : null}
                    />
                  </TableCell>
                  <TableCell size="small">
                    <Field
                      name={`${locationRow}.plotNumber`}
                      component={parcelsAutocompletion ? FormParcelAutocompleteField : FormTextField}
                      validate={applicationForm.locationPlotNumberRequired ? required : null}
                      budgetId={parcelsAutocompletion ? budgetId : undefined}
                      disabled={readonly}
                    />
                  </TableCell>
                  <TableCell padding="none" align="right">
                    <Button onClick={() => fields.remove(index)} disabled={readonly}>
                      <RemoveIcon /> Usuń
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button color="primary" onClick={this.handleAddItem} style={{ marginTop: 16 }} disabled={readonly}>
            <AddIcon style={{ marginRight: 8 }} /> Dodaj lokalizację
          </Button>

          {locations && locations.length > 0 &&
            <div style={{ marginTop: 16, height: 400 }}>
              <Map
                markers={locations && locations.filter(l => l.lat && l.lng).map((l, index) => ({ id: index, lat: l.lat, lng: l.lng, title: (l.address || l.city || l.plotNumber) }))}
                onMarkerMoved={this.handleMarkerMoved}
              />
            </div>
          }
        </div>
      </React.Fragment>
    );
  }
}

BudgetApplicationLocations.propTypes = {
  fields: PropTypes.object,
  meta: PropTypes.object,
  applicationForm: PropTypes.object.isRequired,
  budgetId: PropTypes.string.isRequired,
  parcelsAutocompletion: PropTypes.bool,
  locations: PropTypes.array,
  change: PropTypes.func,
  readonly: PropTypes.bool,
  cms: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(BudgetApplicationLocations);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationLocations.js